import {BRIGHT_GREEN} from '../../globalVariables/GlobalVariables';

interface SuccessCheckMarkProps {
    color?: string;
    backgroundColor?: string;
    size?: number | string;
}

const SuccessCheckMark = ({
    color ='white' ,
    backgroundColor =  BRIGHT_GREEN,
    size = 17
}: SuccessCheckMarkProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 17 17"
        fill="none"
    >
        <g clipPath="url(#clip0_12538_2263)">
            <path
                d="M14.5097 14.5104C17.8292 11.191 17.8292 5.80905 14.5097 2.48959C11.1903 -0.829864 5.80838 -0.829864 2.48892 2.48959C-0.830533 5.80905 -0.830533 11.191 2.48892 14.5104C5.80838 17.8299 11.1903 17.8299 14.5097 14.5104Z"
                fill={backgroundColor}
            />
            <path
                d="M7.49974 11.6062C7.3338 11.6062 7.16786 11.543 7.04096 11.4161L4.63918 9.01434C4.3859 8.76106 4.3859 8.35006 4.63918 8.09678C4.89246 7.8435 5.30346 7.8435 5.55674 8.09678L7.49974 10.0398L11.956 5.58351C12.2093 5.33023 12.6203 5.33023 12.8736 5.58351C13.1268 5.83679 13.1268 6.24779 12.8736 6.50107L7.95852 11.4161C7.83162 11.543 7.66568 11.6062 7.49974 11.6062Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_12538_2263">
                <rect width={size} height={size} fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default SuccessCheckMark;
